import { render, staticRenderFns } from "./Question_simple.vue?vue&type=template&id=14e8aa22&"
import script from "./Question_simple.vue?vue&type=script&lang=js&"
export * from "./Question_simple.vue?vue&type=script&lang=js&"
import style0 from "./Question_simple.vue?vue&type=style&index=0&id=14e8aa22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports